import React, { useState } from "react";
import { MdOutlineSegment } from "react-icons/md";
import { IoClose } from "react-icons/io5";
import { FaArrowRight } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import logoBig from "../Assets/Images/INNOVATIONS_AHEAD-removebg-preview.png";
import bgImg from "../Assets/Images/CTAbgImg.jpg";

const Header = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleDrawer = () => setIsDrawerOpen(!isDrawerOpen);

  const navItems = [
    { label: "About Us", path: "/aboutUs" },
    { label: "Services", path: "/services" },
    { label: "Products", path: "/products" },
    { label: "Careers", path: "/careers" },
    { label: "Corporate Training", path: "/corporateTraining" },
    { label: "Contact Us", path: "/contactUs" },
    { label: "Testimonials", path: "/testimonials" },
  ];

  const handleNavigation = (path) => {
    setIsDrawerOpen(false);
    setTimeout(() => navigate(path), 300);
  };

  return (
    <>
      {/* HEADER */}
      <header className="fixed top-0 left-0 w-full bg-black/60 backdrop-blur-lg shadow-lg z-50 px-4 py-2 border-b border-white/10">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <a href="/" className="flex items-center gap-2 cursor-pointer">
            <img src={logoBig} alt="Logo Big" className="h-8 sm:h-10 md:h-12 lg:h-14"  />
          </a>

          {!isDrawerOpen && (
            <button
              className="text-white transition-transform duration-300 hover:scale-110"
              onClick={toggleDrawer}
            >
              <MdOutlineSegment size={40} />
            </button>
          )}
        </div>
      </header>

      {/* OVERLAY */}
      <div
        className={`fixed inset-0 bg-black/60 backdrop-blur-sm z-40 transition-all duration-500 ${
          isDrawerOpen ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
        onClick={toggleDrawer}
      />

      {/* DRAWER */}
      <div
        className={`fixed top-0 right-0 w-full sm:w-[600px] md:w-[750px] lg:w-[900px] h-full 
        bg-cover bg-center bg-no-repeat
        border-l border-white/10 
        shadow-[0_0_60px_rgba(0,0,0,0.6)]
        z-50 transform transition-all duration-500 ease-[cubic-bezier(0.19,1,0.22,1)]
        ${isDrawerOpen ? "translate-x-0 opacity-100" : "translate-x-full opacity-0"}
        `}
        style={{ backgroundImage: `url(${bgImg})` }}
      >
        {/* Semi-transparent overlay to keep text readable */}
        <div className="absolute inset-0 bg-black/65"></div>

        {/* CLOSE BUTTON */}
        <div className="relative flex justify-end p-4 z-10">
          <button onClick={toggleDrawer} className="hover:rotate-90 transition-transform duration-300">
            <IoClose size={36} className="text-white" />
          </button>
        </div>

        {/* MAIN CONTENT */}
        <div className="relative z-10 flex flex-col md:flex-row min-h-[calc(100vh-80px)]">

          {/* LEFT SIDE - CONTENT */}
          <div className="order-2 md:order-1 w-full md:w-[60%] lg:w-[65%] px-6 md:px-8 flex flex-col text-white border-t md:border-t-0 md:border-r border-white/10">

            <div className="pt-6 space-y-4">
              <h2 className="text-2xl md:text-3xl font-semibold leading-tight">
                Technology Speaks.<br />
                Innovation Leads.<br />
                Future Begins.
              </h2>

              <p className="text-sm md:text-base font-medium text-white/70 leading-relaxed max-w-xl">
                Technology drives progress, innovation shapes possibilities, and the future is built through smart digital solutions.
                We create modern, scalable, and reliable technologies that empower businesses to grow, adapt, and succeed in the digital era.
              </p>
            </div>

            {/* CONTACT */}
            <div className="mt-6 md:mt-auto text-sm text-white/70 space-y-2 pb-4">
              <p className="relative font-medium text-white text-base inline-block">
                Reach us with
                <span className="absolute left-0 -bottom-1 w-full h-[2px] bg-gradient-to-r from-cyan-400 via-blue-500 to-purple-500 rounded-full"></span>
              </p>

              <a href="tel:+916374045002" className="flex gap-2 hover:text-cyan-400 transition">
                <span className="min-w-[140px]">Business Enquiry</span>
                <span className="font-semibold">+91 637 404 5002</span>
              </a>

              <a href="tel:+919092941177" className="flex gap-2 hover:text-cyan-400 transition">
                <span className="min-w-[140px]">For Job</span>
                <span className="font-semibold">+91 909 294 1177</span>
              </a>

              <p className="flex gap-2">
                <span className="min-w-[140px]">Write to Us</span>
                <a href="mailto:info@vivekasoftek.com" className="text-cyan-400 hover:underline">
                  info@vivekasoftek.com
                </a>
              </p>
            </div>
          </div>

          {/* RIGHT SIDE - MENU */}
          <div className="order-1 md:order-2 w-full md:w-[50%] lg:w-[45%] px-6 py-6 md:py-0 flex items-start md:items-center justify-start md:justify-center">
            <div className="flex flex-col space-y-4 sm:space-y-5 md:space-y-6 w-full">

              {navItems.map((item) => {
                const isActive = location.pathname === item.path;

                return (
                  <button
                    key={item.label}
                    onClick={() => handleNavigation(item.path)}
                    className={`group relative flex justify-between items-center text-left font-medium text-lg sm:text-xl md:text-2xl tracking-wide transition-all duration-300
                      ${isActive ? "text-cyan-400" : "text-white hover:text-cyan-400"}
                    `}
                  >
                    {/* TEXT */}
                    <span className="relative">
                      {item.label}

                      {/* ANIMATED UNDERLINE */}
                      <span
                        className={`absolute left-0 -bottom-1 h-[2px] bg-gradient-to-r from-cyan-400 to-blue-500 transition-all duration-300
                          ${isActive ? "w-full" : "w-0 group-hover:w-full"}
                        `}
                      ></span>
                    </span>

                    {/* ARROW */}
                    <FaArrowRight
                      size={18}
                      className={`text-cyan-400 transition-all duration-300 
                        ${isActive ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0"}
                      `}
                    />
                  </button>
                );
              })}
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default Header;